class HighlightBlock extends HTMLElement {
    constructor() {
        super();
        this.opener = this.querySelector('[data-opener]');
        this.tooltip = this.querySelector('[data-tooltip]');
        this.closure = this.querySelector('[data-closure]');
        this.isOpened = false;
        this.openTooltip = this.openTooltip.bind(this);
        this.closeTooltip = this.closeTooltip.bind(this);
        this.handleClickOutside = this.handleClickOutside.bind(this);
    }

    connectedCallback() {
        if (!this.opener || !this.tooltip || !this.closure) return;

        this.bindListeners();
    }

    bindListeners() {
        this.opener.addEventListener('click', this.openTooltip);
        this.closure.addEventListener('click', this.closeTooltip);
        window.addEventListener('click', this.handleClickOutside);
    }

    unbindListeners() {
        this.opener.removeEventListener('click', this.openTooltip);
        this.closure.removeEventListener('click', this.closeTooltip);
        window.removeEventListener('click', this.handleClickOutside);
    }

    openTooltip(e) {
        e.stopPropagation();
        if (!this.isOpened) {
            document.querySelectorAll('[data-tooltip]').forEach(tooltip => tooltip.classList.replace('block', 'hidden'));
            this.tooltip.classList.replace('hidden', 'block');
            this.isOpened = true;
        } else {
            this.tooltip.classList.replace('block', 'hidden');
            this.isOpened = false;
        }
    }

    closeTooltip(e) {
        e.stopPropagation();
        if (this.isOpened) {
            this.tooltip.classList.replace('block', 'hidden');
            this.isOpened = false;
        }
    }

    handleClickOutside(e) {
        // Ensure that click on the tooltip or opener does not close the tooltip
        if (this.isOpened && !this.contains(e.target)) {
            this.closeTooltip(e);
        }
    }

    disconnectedCallback() {
        this.unbindListeners();
    }
}

if (!customElements.get('highlight-block')) {
    customElements.define('highlight-block', HighlightBlock);
}
